<template>
  <div class="wrapper" style="display: flex; flex-direction: column;">
    <NavbarBlack />
    <div
      style="backgroundImage: url(./img/wixbackground.png); background-size: cover; flex-grow: 1; height: 100%;
      width: 100%; display: flex; align-items: center; justify-content: center; text-align: center; margin-bottom: -180px;"
    >
      <div
        class="md-layout-item md-size-40 md-small-size-100"
        style="text-align: center; background-color: white; padding: 40px 60px;"
      >
        <h1
          class="title"
          style="font-family: 'Roboto', serif; color: black; font-size: xx-large;"
        >
          {{ $t("We're sorry to see you go!") }}
        </h1>
        <p>
          {{
            $t(
              "You have been successfully unsubscribed, and will no longer receive our newsletters. You can always update your subscription preference on the profile page if you change your mind."
            )
          }}
        </p>
      </div>
    </div>
    <FooterBlack />
  </div>
</template>

<script>
import FooterBlack from "./Layout/FooterBlack.vue";
import NavbarBlack from "./Layout/NavbarBlack.vue";

export default {
  components: {
    FooterBlack,
    NavbarBlack
  }
};
</script>
